import '../css/app.css'
import { createIcons, icons } from 'lucide'
import Alpine from 'alpinejs'
import TomSelect from 'tom-select';
import 'tom-select/dist/css/tom-select.bootstrap5.min.css'; // Atau css standar
import Chart from 'chart.js/auto'
window.Chart = Chart
window.TomSelect = TomSelect;
window.Alpine  = Alpine


import { registerToast } from './components/toast.js'
import { registerModal }            from './components/modal.js'
import { registerAllSelectComponents } from './components/select.js'

window.initIcons = function initIcons() {
  createIcons({ icons })
}
window.csrf = {
  token: document.querySelector('meta[name="_csrf"]')?.content,
  header: document.querySelector('meta[name="_csrf_header"]')?.content ?? 'X-CSRF-TOKEN'
}
window.apiFetch = async function (url, options = {}) {
    const headers = {
        'Content-Type': 'application/json',
        ...(options.headers || {})
    }

    if (window.csrf.token) {
        headers[window.csrf.header] = window.csrf.token
    }

    const response = await fetch(url, { ...options, headers })

    if (response.status === 401) {
        window.location.href = '/login'
        return null  // ← return null bukan undefined
    }

    if (response.status === 403) {
        window.location.reload()
        return null  // ← return null bukan undefined
    }

    if (!response.ok) {
        let message = 'Terjadi kesalahan'
        try {
            const data = await response.json()
            message = data.message || message
        } catch (_) {}
        throw new Error(message)
    }

    return response
}

window.apiJson = async (url, options = {}) => {
    const res = await apiFetch(url, options)
    if (!res) return null  // ← guard jika null (401/403)
    return res.json()
}
document.addEventListener('modal:open', () => {
  requestAnimationFrame(() => initIcons())
})



document.addEventListener('alpine:init', () => {
    Alpine.magic('rupiah', () => (nilai) => {
        if (nilai == null) return 'Rp 0';
        return new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: 'IDR',
            minimumFractionDigits: 0
        }).format(nilai);
    });
});


// ── Helper: spread yang preserve getter ────────────────────
window.mergeAlpine = function mergeAlpine(...components) {
    return Object.defineProperties(
        {},
        components.reduce((acc, component) => ({
            ...acc,
            ...Object.getOwnPropertyDescriptors(component),
        }), {})
    );
}


// ── Base Factory ───────────────────────────────────────────
window.createListComponent = function createListComponent({
    buildUrl,
    tabName   = null,
    onSuccess = null,
}) {
    return {
        data: [],
        loading: false,
        page: 0,
        size: 10,
        isLast: true,
        isFirst: true,
        totalPages: 0,
        _initialized: false,

        get visiblePages() {
            const range = [];
            const delta = 2;
            const start = Math.max(1, this.page + 1 - delta);
            const end   = Math.min(this.totalPages, this.page + 1 + delta);
            for (let i = start; i <= end; i++) range.push(i);
            return range;
        },
async fetchData(page = 0) {
    this.loading = true;
    this.page    = page;

    try {
        const res  = await apiFetch(buildUrl.call(this, page));
        if (!res) return; // ← 401/403
        const json = await res.json();

        this.data       = json.content    ?? [];
        this.totalPages = json.totalPages ?? 1;
        this.page       = json.number     ?? page;
        this.isFirst    = json.first;
        this.isLast     = json.last;

        if (onSuccess) onSuccess(this);

    } catch (e) {
        console.error('[fetchData] ERROR', e);
        // ← jangan reset this.data = [] saat error
        // data lama lebih baik tetap tampil
        this.totalPages = 0;
        Alpine.store('notify').error('Error', e.message);
    } finally {
        this.loading = false; // ← pindah ke finally agar selalu reset
    }
},
    }
}


registerToast(Alpine)
registerModal(Alpine)
registerAllSelectComponents(Alpine)

Alpine.start()
initIcons()